import { Spinner } from "@/components/common/Common";

// Table on desktop, cards on mobile.
export function DataList({ columns, rows, loading, onRowClick, rowTestId = "row", empty = "No records found", mobileTitle, mobileMeta }) {
  if (loading && !rows.length) {
    return <div className="flex items-center gap-2 text-sm text-slate-500 p-8 justify-center"><Spinner /> Loading…</div>;
  }
  if (!rows.length) {
    return <div className="text-sm text-slate-500 p-10 text-center bg-white border border-dashed border-slate-300 rounded-lg" data-testid="empty-state">{empty}</div>;
  }
  return (
    <>
      <div className="hidden md:block bg-white border border-slate-200 rounded-lg shadow-sm overflow-x-auto">
        <table className="w-full text-sm text-left border-collapse">
          <thead>
            <tr>
              {columns.map((c) => (
                <th key={c.key} className={`bg-slate-50 text-slate-500 font-medium border-b border-slate-200 px-4 py-3 text-xs uppercase tracking-wider ${c.className || ""}`}>{c.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`${rowTestId}-${r.id}`} onClick={() => onRowClick?.(r)}
                className={`border-b border-slate-100 last:border-0 transition-colors ${onRowClick ? "cursor-pointer hover:bg-blue-50/40" : ""}`}>
                {columns.map((c) => (
                  <td key={c.key} className={`px-4 py-3 text-slate-700 ${c.className || ""}`}>{c.render ? c.render(r) : r[c.key] || "—"}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="md:hidden space-y-3">
        {rows.map((r) => (
          <div role={onRowClick ? "button" : undefined} key={r.id} data-testid={`${rowTestId}-card-${r.id}`} onClick={() => onRowClick?.(r)}
            className="w-full text-left bg-white border border-slate-200 rounded-lg p-4 shadow-sm active:bg-slate-50">
            <div className="font-semibold text-slate-900">{mobileTitle ? mobileTitle(r) : r.name}</div>
            <div className="mt-2 grid grid-cols-2 gap-x-3 gap-y-1 text-xs">
              {columns.slice(1).map((c) => (
                <div key={c.key} className="min-w-0">
                  <span className="text-slate-400">{c.label}: </span>
                  <span className="text-slate-700 break-words">{c.render ? c.render(r) : r[c.key] || "—"}</span>
                </div>
              ))}
            </div>
            {mobileMeta && <div className="mt-2">{mobileMeta(r)}</div>}
          </div>
        ))}
      </div>
    </>
  );
}
